import { InjectionToken } from '@angular/core';
import { TalkJsConfig } from './types';

export const TalkJsConfigToken = new InjectionToken<TalkJsConfig>(
  'TalkJsConfig',
);
